module.exports = __webpack_public_path__ + "img/save.5d230657.svg";